import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import PickerItem from '../../containers/picker-item';
import PhotoInfo from '../../containers/photo-info';

const PickerItemBlock = props => <PickerItem {...props} />;
PickerItemBlock.displayName = 'PickerItem';

export default withDynamicComponents({
  componentWhitelist: [
    PhotoInfo,
  ],
  mapInputToOutput: [
    ['photoInfo', 'photoInfo'],
  ],
})(PickerItemBlock);



// WEBPACK FOOTER //
// ./src/blocks/picker-item/index.jsx